import { FC, useState } from "react";

import { ReportSectionsType } from "@api/graphql/types-and-hooks";
import { ReportSectionActionMenuRemoveDialog } from "@components/ReportField/ReportSection/ReportSectionActionMenu/ReportSectionActionMenuRemove";
import { useRegenerateSection } from "@components/ReportField/ReportSection/useRegenerateSection";
import { useCanDeleteSection } from "@components/ReportField/capabilities";
import { SectionRecoveryPanel } from "@components/SectionWidget/SectionRecoveryPanel";

interface ReportSectionRecoveryProps {
  section: ReportSectionsType;
  /**
   * Still SECTION_PREDICTION_PENDING server-side, but generating past the stall threshold
   * rather than failed. Offers Regenerate but withholds Remove. (PROA-2110)
   */
  isStalled?: boolean;
}

// Shown in place of section content when generation failed or stalled. Regenerate lives
// here rather than in the action menu, which stays hidden while the section is pending.
export const ReportSectionRecovery: FC<ReportSectionRecoveryProps> = ({ section, isStalled = false }) => {
  const canDelete = useCanDeleteSection(section);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const { mutate: startWorkflowMutate, isPending: isRegenerating } = useRegenerateSection();

  return (
    <>
      <SectionRecoveryPanel
        isStalled={isStalled}
        canRemove={canDelete}
        isRegenerating={isRegenerating}
        onRegenerateCallback={() => startWorkflowMutate({ sectionId: section.id })}
        onDeleteCallback={() => setIsDeleteDialogOpen(true)}
        regenerateClassName="ml-2 text-blurple-600"
      />
      <ReportSectionActionMenuRemoveDialog
        section={section}
        open={isDeleteDialogOpen}
        onOpenChange={setIsDeleteDialogOpen}
      />
    </>
  );
};
